import { render, staticRenderFns } from "./AboutUsTimeLine.vue?vue&type=template&id=2c0b7289&lang=html&"
import script from "./AboutUsTimeLine.vue?vue&type=script&lang=js&"
export * from "./AboutUsTimeLine.vue?vue&type=script&lang=js&"
import style0 from "./AboutUsTimeLine.vue?vue&type=style&index=0&id=2c0b7289&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports